var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{staticClass:"intput-date",attrs:{"monday-first":"","input-class":_vm.hasError ? 'input is-danger' : 'input',"language":_vm.$options.datepickerLocales[_vm.$language.current],"highlighted":{ dates: [new Date()] },"disabled-dates":_vm.disabledDates,"required":_vm.required,"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }